import { render, staticRenderFns } from "./TodoEdit.vue?vue&type=template&id=122ed9f8"
import script from "./TodoEdit.vue?vue&type=script&lang=ts"
export * from "./TodoEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports